import { FC } from 'react';
import { IRecording } from '../../appointments/recording/RecordingState';
import { Text } from '../../components/Text';
import { CircleCheckIcon } from '../../theme/Icons';
import { useBreakpoints } from '../../theme/useBreakpoints';

export type INotesListActionItemCountProps = {
    recording?: IRecording;
};

export const NotesListActionItemCount: FC<INotesListActionItemCountProps> = ({ recording }) => {
    const { isAboveCustomBreakpoint } = useBreakpoints();
    const count = recording?.summary?.actionItems?.length;

    return Boolean(count) && (
        <div style={{display: 'flex', alignItems: 'center', gap: 4}}>
            <CircleCheckIcon color="success" />
            <Text color="success">
                <div style={{fontSize: 14}}>{count} {isAboveCustomBreakpoint(410) ? 'action items' : 'actions'}</div>
            </Text>
        </div>
    );
};
